import Loading from '@@/core/components/shared/Loading/Loading'
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBModal, VBToggle} from "bootstrap-vue";
import mixins from "@@/core/mixins/mixins";
import FormModal from "@@/core/libraries/form/FormModal";
import { method } from 'lodash';

export default {
  name: 'Seller',
  components: {
    Loading,BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, FormModal
  },
  directives: {
    'b-toggle': VBToggle, 'b-modal': VBModal,
  },
  mixins: [mixins],
  mounted() {
    this.loadItems();
    this.loadStores();
  },
  data() {
    return {
      url: 'admin/sellers',
      fields: [{
        key: 'id',
        label: 'شناسه'
      },
        {
          key: 'full_name',
          label: 'نام و نام خانوادگی'
        },
        {
          key: 'national_code',
          label: 'کد ملی'
        },
        {
          key: 'password',
          label: 'کد فروشنده'
        },
        {
          key: 'store',
          label: 'انبار',
        },
        {
          key: 'active',
          label: 'وضعیت'
        },
        {
          key: 'created_at',
          label: 'تاریخ ثبت'
        },
        {
          key: 'edit',
          label: 'ویرایش'
        },
        {
          key: 'delete',
          label: 'حذف'
        },
      ],
      // widget: [
      //   {store: []}
      // ],
      filter: {
        store_id: ''
      },
      widgets: [
        'stores'
      ],
      status_options: [{
        name: 'فعال',
        value: '1'
      },
        {
          name: 'غیرفعال',
          value: '0'
        },
        {
          name: 'همه',
          value: ''
        },
      ],
    }
  },
   watch: {
    // 'filter.status': function (newVal) {
    //   if (typeof newVal === 'string' || typeof newVal === 'number') {
    //     this.filter.status = this.status_options.find(item => {
    //       return item.value == newVal
    //     })
    //   }
    // },
    'filter.store_id': function (newVal) {
      this.onLoadHandlers.push(() => {
        if (typeof newVal === 'string' || typeof newVal === 'number') {
          this.filter.store_id = this.widgetData.stores.find(item => {
            return item.id == newVal
          })
        }
      })
    },
  },
  methods: {
    async filterItem(page = 1) {
      this.searchParams = {
        search1: this.filter.store_id != null ? this.filter.store_id.id : '',
        searchBy1: 'store_id',
      }
    }
  }
}
